import { DISTRIBUTION_URL } from "../../../services/common-urls";
import { JSON_STRING, MHTTPCL } from "../../../services/http/http-client";

export const ShopsService = {
  getShopsData: () =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      section: "shops",
      action: "home"
    }),
  getShops: () =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shops"
    }),
  getShopsScroll: (channel, search_term, start) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shops",
      channel,
      search_term,
      start
    }),
  searchShops: (channel, search_term) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shops",
      channel,
      search_term
    }),
  shopChannels: () =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "all_shops_tab"
    }),
  getShopManagement: () =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "reports",
      action: "clean_shop_names"
    }),
  saveShopName: (relation_id, shop) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "reports",
      action: "check_shop_name",
      relation_id,
      shop
    }),
  updateShopName: () =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "reports",
      action: "update_shop_names"
    }),
  updateShops: () =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "update_shops"
    }),
  fetchShopDetailsTabOverview: shop_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_shop_overview_tab_data",
      shop_id
    }),
  newShopGroups: shop_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "get_unrelated_shop_groups",
      shop_id
    }),

  // newTrackCredit: () => MHTTPCL.post(LABEL_URL, {
  //   section: 'tracks',
  //   action: 'track_credit_form'
  // }),

  // detailsTrackInfo: ({ track_info_id }) => MHTTPCL.post(LABEL_URL, {
  //   section: 'tracks',
  //   action: 'edit_track_info',
  //   track_info_id
  // }),

  detailsShopGroup: ({ shop_group_id }) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "add_shop_groups",
      shop_group_id
    }),

  submitShopGroup: (shop_group_id, shop_id) =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "add_related_shop_group",
      shop_group_id,
      shop_id
    }),
  removeShopGroup: shop_relation_id =>
    MHTTPCL.post(DISTRIBUTION_URL, {
      section: "shops",
      action: "remove_shop_relation",
      shop_relation_id
    }),
    removeShop:(shop_id)=>MHTTPCL.post(DISTRIBUTION_URL,{
      section	:"shops",
      action	:"remove_shop",
      shop_id	:shop_id
    })

};
